import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

import {
  FaHome,
  FaGraduationCap,
  FaIdCard,
  FaUniversity,
  FaReceipt,
  FaBriefcase,
  FaLaptop,
  FaUser,
  FaFilePdf,
  FaFileImage,
  FaTimes,
  FaExternalLinkAlt,
  FaFolderOpen,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCheckCircle,
  FaFileAlt,
  FaBuilding,
  FaImages,
} from "react-icons/fa";

import "./CSC.css";

/* =========================================================
   BASE PATHS
========================================================= */

const DOC_BASE = "/csc/documents";
const CENTRE_BASE = "/csc/photos/centre";
const ACTIVITY_BASE = "/csc/photos/activities";

/* =========================================================
   COMBINED APPLICATION PDF
========================================================= */

const applicationPdf = `${DOC_BASE}/sachin-pote-application.pdf`;

/* =========================================================
   DOCUMENT GROUPS
========================================================= */

const documentGroups = [
  {
    number: "01",
    title: "Residence Certificate",
    icon: <FaHome />,
    documents: [
      {
        name: "Residence Certificate",
        file: "residence.pdf",
      },
    ],
  },

  {
    number: "02",
    title: "Educational Proofs",
    icon: <FaGraduationCap />,
    documents: [
      {
        name: "Leaving Certificate / Transfer Certificate",
        file: "leaving-certificate.JPG",
      },
      {
        name: "SSC – 10th Class Certificate",
        file: "ssc.jpg",
      },
      {
        name: "HSC – 12th Class Certificate",
        file: "hsc.jpg",
      },
      {
        name: "Diploma – Diploma in Teacher Education",
        file: "diploma.jpg",
      },
      {
        name: "Graduation – Bachelor of Arts",
        file: "graduation.jpg",
      },
      {
        name: "Post Graduate – Master of Arts",
        file: "post-graduation.jpg",
      },
    ],
  },

  {
    number: "03",
    title: "Aadhaar & Identity",
    icon: <FaIdCard />,
    documents: [
      {
        name: "Aadhaar Card",
        file: "aadhaar.jpg",
      },
      {
        name: "PAN Card",
        file: "pan.jpg",
      },
    ],
  },

  {
    number: "04",
    title: "Bank Details",
    icon: <FaUniversity />,
    documents: [
      {
        name: "Bank Details / Passbook",
        file: "bank-details.pdf",
      },
    ],
  },

  {
    number: "05",
    title: "ITR – Previous Two Years",
    icon: <FaReceipt />,
    documents: [
      {
        name: "ITR – Previous Year 1",
        file: "itr-2025.pdf",
      },
      {
        name: "ITR – Previous Year 2",
        file: "itr-2026.pdf",
      },
    ],
  },

  {
    number: "06",
    title: "Experience Certificates",
    icon: <FaBriefcase />,
    documents: [
      {
        name: "CSC Experience",
        file: "experience-csc.pdf",
      },
      {
        name: "Banking – Bank Mitra",
        file: "experience-banking.pdf",
      },
      {
        name: "UIDAI Aadhaar Supervisor",
        file: "experience-aadhaar.pdf",
      },
      {
        name: "Skill India Digital Hub – Trainer",
        file: "experience-trainer.pdf",
      },
      {
        name: "Skill India Digital Hub – Assessor",
        file: "experience-assessor.pdf",
      },
    ],
  },

  {
    number: "07",
    title: "Character Certificate / Application Receipt",
    icon: <FaFilePdf />,
    documents: [
      {
        name: "Character Certificate / Application Receipt",
        file: "character.pdf",
      },
    ],
  },

  {
    number: "08",
    title: "Self Declaration",
    icon: <FaFileAlt />,
    documents: [
      {
        name: "Self Declaration",
        file: "self-declaration.jpeg",
      },
    ],
  },

  {
    number: "09",
    title: "Computer Certificates",
    icon: <FaLaptop />,
    documents: [
      {
        name: "MS-CIT",
        file: "mscit.jpg",
      },
      {
        name: "Cyber Security Certificate",
        file: "cyber-security.pdf",
      },
      {
        name: "Typing English – 40 WPM",
        file: "typing-english-40..jpg",
      },
      {
        name: "Typing English – 30 WPM",
        file: "typing-english-30.jpg",
      },
      {
        name: "Typing Marathi – 30 WPM",
        file: "typing-marathi-30.jpg",
      },
    ],
  },

  {
    number: "10",
    title: "Fee Payment Receipt",
    icon: <FaReceipt />,
    documents: [
      {
        name: "Fee Payment Receipt",
        file: "fee-receipt.jpeg",
      },
    ],
  },

  {
    number: "11",
    title: "Social Inclusion",
    icon: <FaUser />,
    documents: [
      {
        name: "Local Entrepreneur – Supporting Document",
        file: "social-inclusion.pdf",
      },
    ],
  },

  {
    number: "12",
    title: "Rent Agreement & Owner Tax Receipt",
    icon: <FaHome />,
    documents: [
      {
        name: "Rent Agreement",
        file: "rent-agreement.pdf",
      },
      {
        name: "Owner Tax Receipt",
        file: "tax-receipt.pdf",
      },
    ],
  },
];

/* =========================================================
   CENTRE PHOTOS
========================================================= */

const centrePhotos = [
  {
    file: "office-front.jpg",
    title: "CSC Centre – Front View",
  },
  {
    file: "office-interior.jpg",
    title: "CSC Centre – Interior",
  },
  {
    file: "computers.jpg",
    title: "Computer Infrastructure",
  },
  {
    file: "infrastructure.jpg",
    title: "Centre Infrastructure",
  },
];

/* =========================================================
   ACTIVITY PHOTOS
========================================================= */

const activityPhotos = [
  {
    file: "activities1.jpg",
    title: "Citizen Service Activity 01",
  },
  {
    file: "activities2.jpg",
    title: "Citizen Service Activity 02",
  },
  {
    file: "activities3.jpg",
    title: "Citizen Service Activity 03",
  },
  {
    file: "activities4.jpg",
    title: "Citizen Service Activity 04",
  },
  {
    file: "activities5.jpg",
    title: "Citizen Service Activity 05",
  },
  {
    file: "activities6.jpg",
    title: "Citizen Service Activity 06",
  },
  {
    file: "activities7.jpg",
    title: "Citizen Service Activity 07",
  },
];

/* =========================================================
   HELPER - FILE TYPE
========================================================= */

const getFileType = (fileName) => {
  const extension = fileName.split(".").pop().toLowerCase();

  if (["jpg", "jpeg", "png", "webp", "gif"].includes(extension)) {
    return "image";
  }

  return "pdf";
};

/* =========================================================
   DOCUMENT CARD
========================================================= */

function DocumentCard({ document, onOpen }) {
  const path = `${DOC_BASE}/${document.file}`;
  const type = getFileType(document.file);
  const isImage = type === "image";

  return (
    <button
      type="button"
      className="csc-doc-card"
      onClick={() =>
        onOpen({
          name: document.name,
          path,
          type,
        })
      }
    >
      <div className="csc-doc-preview">
        {isImage ? (
          <img
            src={path}
            alt={document.name}
            className="csc-card-image"
          />
        ) : (
          <div className="csc-preview-paper">
            <FaFilePdf />
            <span>PDF</span>
          </div>
        )}
      </div>

      <div className="csc-doc-info">
        <span className="csc-doc-type">
          {isImage ? "IMAGE DOCUMENT" : "PDF DOCUMENT"}
        </span>

        <strong>{document.name}</strong>

        <small>
          Click to view
          <FaExternalLinkAlt />
        </small>
      </div>
    </button>
  );
}

/* =========================================================
   PHOTO CARD
========================================================= */

function PhotoCard({ photo, basePath, onOpen }) {
  const path = `${basePath}/${photo.file}`;

  return (
    <button
      type="button"
      className="csc-photo-card"
      onClick={() =>
        onOpen({
          name: photo.title,
          path,
          type: "image",
        })
      }
    >
      <div className="csc-photo-wrapper">
        <img src={path} alt={photo.title} />
        <div className="csc-photo-overlay">
          <FaImages />
          <span>View</span>
        </div>
      </div>

      <div className="csc-photo-title">
        {photo.title}
      </div>
    </button>
  );
}

/* =========================================================
   MODAL
========================================================= */

function FileModal({ modal, onClose }) {
  useEffect(() => {
    if (!modal) {
      document.body.style.overflow = "";
      return;
    }

    document.body.style.overflow = "hidden";

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscape);
    };
  }, [modal, onClose]);

  if (!modal) {
    return null;
  }

  return (
    <div
      className="csc-modal-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className={`csc-modal ${
          modal.type === "image"
            ? "csc-image-modal"
            : "csc-pdf-modal"
        }`}
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={modal.name}
      >
        <div className="csc-modal-header">
          <div className="csc-modal-title">
            {modal.type === "image" ? (
              <FaFileImage />
            ) : (
              <FaFilePdf />
            )}

            <span>{modal.name}</span>
          </div>

          <button
            type="button"
            className="csc-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes />
          </button>
        </div>

        <div className="csc-modal-content">
          {modal.type === "image" ? (
            <img
              src={modal.path}
              alt={modal.name}
              className="csc-modal-image"
            />
          ) : (
            <iframe
              src={`${modal.path}#toolbar=1&navpanes=0&scrollbar=1`}
              title={modal.name}
              className="csc-modal-pdf"
            />
          )}
        </div>
      </div>
    </div>
  );
}

/* =========================================================
   MAIN CSC COMPONENT
========================================================= */

function CSC() {
  const [modal, setModal] = useState(null);

  const openModal = (file) => {
    setModal(file);
  };

  const closeModal = () => {
    setModal(null);
  };

  return (
    <div className="csc-page">

      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <Navbar />

      {/* =====================================================
          PAGE HEADER
      ===================================================== */}

      <header className="csc-header">
        <div className="csc-container">

          <div className="csc-header-top">

            <div>
              <div className="csc-kicker">
                AAPLE SARKAR SEVA KENDRA 2026
              </div>

              <h1>
                Application Portfolio
              </h1>

              <p>
                आपले सरकार सेवा केंद्र – Application
                Document Portfolio
              </p>
            </div>

            <div className="csc-location-box">
              <FaMapMarkerAlt />

              <div>
                <span>Selected Location</span>
                <strong>Jamb Bu.</strong>
                <small>
                  Jintur, Parbhani
                </small>
              </div>
            </div>

          </div>

          {/* =================================================
              COMBINED PDF
          ================================================= */}

          <div className="csc-application-file">

            <div className="csc-application-icon">
              <FaFilePdf />
            </div>

            <div className="csc-application-content">
              <span>
                COMPLETE APPLICATION FILE
              </span>

              <strong>
                SACHIN POTE APPLICATION FILE
              </strong>

              <small>
                Complete sequence-wise application
                documents in a single PDF
              </small>
            </div>

            <button
              type="button"
              className="csc-application-button"
              onClick={() =>
                openModal({
                  name: "SACHIN POTE APPLICATION FILE",
                  path: applicationPdf,
                  type: "pdf",
                })
              }
            >
              <FaFolderOpen />
              Open File
            </button>

          </div>

        </div>
      </header>

      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <main className="csc-main">
        <div className="csc-container">

          {/* =================================================
              APPLICANT INFORMATION
          ================================================= */}

          <section className="csc-section">

            <div className="csc-section-heading">

              <div>
                <span className="csc-section-number">
                  01
                </span>

                <div>
                  <span className="csc-eyebrow">
                    APPLICANT DETAILS
                  </span>

                  <h2>
                    Applicant Information
                  </h2>
                </div>
              </div>

              <div className="csc-section-location">
                <FaMapMarkerAlt />
                Jamb Bu.
              </div>

            </div>

            <div className="csc-applicant-card">

              <div className="csc-applicant-main">

                <div className="csc-applicant-avatar">
                  SP
                </div>

                <div>
                  <span className="csc-label">
                    APPLICANT NAME
                  </span>

                  <h3>
                    POTE SACHIN SADASHIVRAO
                  </h3>

                  <p>
                    Applicant for Aaple Sarkar Seva
                    Kendra 2026
                  </p>
                </div>

              </div>

              <div className="csc-status">
                <FaCheckCircle />
                Application Portfolio
              </div>

            </div>

            <div className="csc-info-grid">

              <div className="csc-info-item">
                <span>Village</span>
                <strong>Jamb Bu.</strong>
              </div>

              <div className="csc-info-item">
                <span>Taluka</span>
                <strong>Jintur</strong>
              </div>

              <div className="csc-info-item">
                <span>District</span>
                <strong>Parbhani</strong>
              </div>

              <div className="csc-info-item">
                <span>Age</span>
                <strong>35 Years</strong>
              </div>

              <div className="csc-info-item">
                <span>Gender</span>
                <strong>Male</strong>
              </div>

              <div className="csc-info-item">
                <span>Educational Qualification</span>
                <strong>Post Graduate</strong>
              </div>

              <div className="csc-info-item">
                <span>Computer Certification</span>
                <strong>MS-CIT</strong>
              </div>

              <div className="csc-info-item">
                <span>CSC ID</span>
                <strong>155336930012</strong>
              </div>

              <div className="csc-info-item csc-info-wide">
                <span>Address</span>
                <strong>
                  99, Near Z P School, At. Post. Jamb Bk
                  Tq. Jintur, Dist. Parbhani
                </strong>
              </div>

              <div className="csc-info-item">
                <span>Mobile</span>
                <strong className="csc-contact-value">
                  <FaPhone />
                  7722000088
                </strong>
              </div>

              <div className="csc-info-item csc-info-wide">
                <span>Email</span>
                <strong className="csc-contact-value">
                  <FaEnvelope />
                  sachinpote143@gmail.com
                </strong>
              </div>

            </div>

          </section>

          {/* =================================================
              DOCUMENTS
          ================================================= */}

          <section className="csc-section">

            <div className="csc-section-heading">

              <div>
                <span className="csc-section-number">
                  02
                </span>

                <div>
                  <span className="csc-eyebrow">
                    DOCUMENT PORTFOLIO
                  </span>

                  <h2>
                    Application Documents
                  </h2>
                </div>
              </div>

              <span className="csc-document-note">
                Click any document to view
              </span>

            </div>

            <div className="csc-document-groups">

              {documentGroups.map((group) => (
                <div
                  className="csc-document-group"
                  key={group.number}
                >

                  <div className="csc-group-header">

                    <div className="csc-group-number">
                      {group.number}
                    </div>

                    <div className="csc-group-icon">
                      {group.icon}
                    </div>

                    <div className="csc-group-title">
                      <span>
                        DOCUMENT SECTION
                      </span>

                      <h3>
                        {group.title}
                      </h3>
                    </div>

                    <div className="csc-group-count">
                      {group.documents.length}{" "}
                      {group.documents.length === 1
                        ? "Document"
                        : "Documents"}
                    </div>

                  </div>

                  <div className="csc-doc-grid">

                    {group.documents.map(
                      (document) => (
                        <DocumentCard
                          key={document.file}
                          document={document}
                          onOpen={openModal}
                        />
                      )
                    )}

                  </div>

                </div>
              ))}

            </div>

          </section>

          {/* =================================================
              BANK STATEMENT
          ================================================= */}

          <section className="csc-section">

            <div className="csc-section-heading">

              <div>
                <span className="csc-section-number">
                  03
                </span>

                <div>
                  <span className="csc-eyebrow">
                    SUPPORTING FINANCIAL DOCUMENT
                  </span>

                  <h2>
                    Bank Statement
                  </h2>
                </div>
              </div>

            </div>

            <div className="csc-bank-statement-card">

              <div className="csc-bank-icon">
                <FaUniversity />
              </div>

              <div className="csc-bank-content">

                <span>
                  BANK STATEMENT
                </span>

                <h3>
                  HDFC Bank – Bank Statement
                </h3>

                <p>
                  Complete bank statement is available
                  separately for verification.
                </p>

              </div>

              <button
                type="button"
                className="csc-primary-button"
                onClick={() =>
                  openModal({
                    name: "HDFC Bank – Bank Statement",
                    path: `${DOC_BASE}/bank-statement.pdf`,
                    type: "pdf",
                  })
                }
              >
                <FaFolderOpen />
                Open Statement
              </button>

            </div>

          </section>

          {/* =================================================
              CENTRE PHOTOS
          ================================================= */}

          <section className="csc-section">

            <div className="csc-section-heading">

              <div>
                <span className="csc-section-number">
                  04
                </span>

                <div>
                  <span className="csc-eyebrow">
                    CENTRE INFRASTRUCTURE
                  </span>

                  <h2>
                    CSC Centre Photographs
                  </h2>
                </div>
              </div>

            </div>

            <div className="csc-photo-grid">

              {centrePhotos.map((photo) => (
                <PhotoCard
                  key={photo.file}
                  photo={photo}
                  basePath={CENTRE_BASE}
                  onOpen={openModal}
                />
              ))}

            </div>

            <div className="csc-photo-info">
              <FaBuilding />

              <span>
                Centre photographs demonstrate the
                proposed CSC centre infrastructure,
                seating and computer facilities.
              </span>
            </div>

          </section>

          {/* =================================================
              SOCIAL / GOVERNMENT ACTIVITIES
          ================================================= */}

          <section className="csc-section">

            <div className="csc-section-heading">

              <div>
                <span className="csc-section-number">
                  05
                </span>

                <div>
                  <span className="csc-eyebrow">
                    CITIZEN SERVICE ACTIVITIES
                  </span>

                  <h2>
                    Government Scheme & Citizen
                    Service Activities
                  </h2>
                </div>
              </div>

            </div>

            <div className="csc-activity-intro">

              <div className="csc-activity-icon">
                <FaImages />
              </div>

              <div>
                <h3>
                  शासकीय योजना नागरिकांपर्यंत
                  पोहचविण्याकरिता राबवलेले उपक्रम
                </h3>

                <p>
                  Citizen service and government
                  scheme activities carried out for
                  awareness and service delivery.
                  Click on any photograph to view it
                  in larger size.
                </p>
              </div>

            </div>

            <div className="csc-photo-grid csc-activity-grid">

              {activityPhotos.map((photo) => (
                <PhotoCard
                  key={photo.file}
                  photo={photo}
                  basePath={ACTIVITY_BASE}
                  onOpen={openModal}
                />
              ))}

            </div>

          </section>

          {/* =================================================
              DECLARATION / SUMMARY
          ================================================= */}

          <section className="csc-final-summary">

            <div className="csc-summary-icon">
              <FaCheckCircle />
            </div>

            <div>
              <span>
                APPLICATION PORTFOLIO
              </span>

              <h2>
                POTE SACHIN SADASHIVRAO
              </h2>

              <p>
                Aaple Sarkar Seva Kendra 2026 –
                Jamb Bu., Taluka Jintur,
                District Parbhani
              </p>
            </div>

            <div className="csc-summary-location">
              <FaMapMarkerAlt />
              Jamb Bu.
            </div>

          </section>

        </div>
      </main>

      {/* =====================================================
          FOOTER
      ===================================================== */}

      <Footer />

      {/* =====================================================
          MODAL
      ===================================================== */}

      <FileModal
        modal={modal}
        onClose={closeModal}
      />

    </div>
  );
}

export default CSC;